import { ToggleControl as WPToggleControl } from '@wordpress/components';

const ToggleControl = ({ field, value, onChange }) => (
    <WPToggleControl
        label={field.label}
        checked={!!value}
        onChange={(checked) => onChange(checked)}
        __next40pxDefaultSize
        __nextHasNoMarginBottom
    />
);

export default ToggleControl;